import {
  GET_ROOMS,
  UPLOAD_FILES,
  GET_MESSAGES,
  GET_ARCHIVE,
  UPDATE_ARCHIVE,
  SEEN_MESSAGES,
  GET_UNSEEN_MESSAGES,
} from "./constants";

export function getRooms( tenantType) {
  return {
    type: GET_ROOMS,
    tenantType
    
  };
}

export function uploadFiles(payload) {
  return {
    type: UPLOAD_FILES,
    payload,
  };
}

export function getMessages(payload) {
  return {
    type: GET_MESSAGES,
    payload,
  };
}
export function updateArchiveMessage(payload) {
  return {
    type: UPDATE_ARCHIVE,
    payload,
  };
}
export function getArchiveMessages(tenantType) {
  return {
    type: GET_ARCHIVE,
    tenantType
  };
}

export function seenMessages(payload) {
  return {
    type: SEEN_MESSAGES,
    payload
  };
}
export function getUnSeenMessages(payload) {
  return {
    type: GET_UNSEEN_MESSAGES,
    payload,
  };
}

